document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.ugc-gallery').forEach(function (gallery) {
    var lightbox = gallery.querySelector('.ugc-gallery__lightbox');
    var body = gallery.querySelector('.ugc-gallery__lightbox-body');
    var closeButton = gallery.querySelector('.ugc-gallery__lightbox-close');

    var slider = gallery.querySelector('.ugc-gallery__slider');
    var prevButton = gallery.querySelector('[data-ugc-prev]');
    var nextButton = gallery.querySelector('[data-ugc-next]');

    if (slider && (prevButton || nextButton)) {
      var scrollByOneItem = function (direction) {
        var item = slider.querySelector('.ugc-gallery__item');
        if (!item) return;
        var itemWidth = item.getBoundingClientRect().width;
        var gap = parseFloat(getComputedStyle(slider).gap) || 0;
        slider.scrollBy({ left: direction * (itemWidth + gap), behavior: 'smooth' });
      };

      if (prevButton) {
        prevButton.addEventListener('click', function () {
          scrollByOneItem(-1);
        });
      }

      if (nextButton) {
        nextButton.addEventListener('click', function () {
          scrollByOneItem(1);
        });
      }
    }

    if (!lightbox || !body) return;

    // Track where each panel came from, so we can move it back on close
    // instead of destroying and recreating it (which broke video playback
    // and could leave images half-loaded).
    var activePanel = null;
    var activePanelParent = null;
    var activePanelNextSibling = null;
    var lastFocusedElement = null;

    var openLightbox = function (panel, trigger) {
      activePanel = panel;
      activePanelParent = panel.parentNode;
      activePanelNextSibling = panel.nextSibling;
      lastFocusedElement = trigger;

      panel.hidden = false;
      body.appendChild(panel);

      lightbox.hidden = false;
      // Let the browser paint the unhidden state before animating in.
      requestAnimationFrame(function () {
        lightbox.classList.add('is-visible');
      });

      document.body.style.overflow = 'hidden';

      if (closeButton) {
        closeButton.focus();
      }
    };

    var closeLightbox = function () {
      if (!activePanel) return;

      // Pause any playing video so it doesn't keep running off-screen.
      var video = activePanel.querySelector('video');
      if (video) {
        video.pause();
      }

      lightbox.classList.remove('is-visible');
      lightbox.hidden = true;
      document.body.style.overflow = '';

      activePanel.hidden = true;
      if (activePanelNextSibling) {
        activePanelParent.insertBefore(activePanel, activePanelNextSibling);
      } else {
        activePanelParent.appendChild(activePanel);
      }

      if (lastFocusedElement) {
        lastFocusedElement.focus();
      }

      activePanel = null;
      activePanelParent = null;
      activePanelNextSibling = null;
      lastFocusedElement = null;
    };

    gallery.querySelectorAll('[data-ugc-open]').forEach(function (button) {
      button.addEventListener('click', function () {
        var id = button.getAttribute('data-ugc-open');
        var panel = gallery.querySelector('#ugc-panel-' + id);
        if (!panel) return;
        openLightbox(panel, button);
      });
    });

    lightbox.querySelectorAll('[data-ugc-close]').forEach(function (closer) {
      closer.addEventListener('click', closeLightbox);
    });

    // Belt-and-braces: a click anywhere on the lightbox root itself
    // (not on the frame with the image/text) should also close it.
    lightbox.addEventListener('click', function (event) {
      if (event.target === lightbox) {
        closeLightbox();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !lightbox.hidden) {
        closeLightbox();
      }
    });
  });
});